module.exports = __webpack_public_path__ + "img/2019091805.92f18a00.png";